import script from "./NavigationMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationMenu.vue?vue&type=style&index=0&id=d138fb78&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d138fb78"]])

export default __exports__